import React from 'react';
import BaseComponent, {AjaxParam} from '@components/base/BaseComponent/BaseComponent';
import HelperGoogleAnalytics4 from '../common/helpers/HelperGoogleAnalytics4';
import {notify} from "@contexts/ContextNotificationProvider";

const ContextSocialLogin = React.createContext({});


/**
 * @class ContextSocialLoginProvider
 *
 */
class ContextSocialLoginProvider extends BaseComponent {


	constructor(props) {

		super(props);
		const contextName = 'socialLoginProvider';
		this.componentName = SHVO.pageState.componentData[contextName].componentName;
		this.componentToken = SHVO.pageState.componentData[contextName].componentToken;
		this.config = SHVO.pageState.componentData[contextName].componentData.socialLoginConfig;
		this.state = {
			facebookScope: this.config.facebook.scope
		}


		const googleConfig = this.config.google;
		const thisContext = this;
		const facebookConfig = this.config.facebook;

		window.fbAsyncInit = function () {
			try {
				if (window.FB) {
					FB.init({
						appId: facebookConfig.app_id,
						cookie: facebookConfig.cookie,
						xfbml: facebookConfig.xfbml,
						version: facebookConfig.version
					});

					FB.Event.subscribe('auth.statusChange', response => {
						if (response.authResponse) {
							thisContext.loginFacebook();
						} else {

						}
					});
				}

			} catch (error) {
				console.error(error);
			}

		};

		window.renderGoogleLoginButton = function () {

			try {
				if (window.google) {
					var d = document;

					google.accounts.id.initialize({
						client_id: googleConfig.client_id,
						callback: thisContext.googleOnSuccess
					});
					google.accounts.id.renderButton(d.getElementById("googleLoginButton"), {
						'type': 'standard',
						'theme': 'filled_blue',
						'size': 'large',
						'width': 243
					});
				}
			} catch (e) {
				console.error(e);

			}
		}
	}

	loginFacebook = () => {
		let thisContext = this;

		FB.getLoginStatus(
			function (response) {

				if (response.status === 'connected') {

					let ajaxParam = new AjaxParam();
					ajaxParam.callbackSuccess = (data) => {
						const {componentNewURL} = data;
						if (componentNewURL !== '' && componentNewURL !== undefined) {
							thisContext.navigate(componentNewURL);
						} else {
							window.location.reload();
						}

					};
					ajaxParam.callbackError = (data) => {
						const {componentErrors} = data;
						if (componentErrors) {
							const errMsg = componentErrors[0];
							notify.error(thisContext.messages[errMsg] || errMsg);
							window.location.reload();
						}
					};

					HelperGoogleAnalytics4.TrackLoginEvent('Facebook');

					thisContext.ajaxCall('ActionFacebookLogin', {
						token: response.authResponse.accessToken,
						rememberMe: thisContext.props.rememberMe
					}, ajaxParam);

				} else {

				}

			}
		);
	}


	googleOnSuccess = (response) => {
		const token = response.credential;
		const thisContext = this;

		if (token) {
			let ajaxParam = new AjaxParam();
			ajaxParam.callbackSuccess = (data) => {
				const {componentNewURL} = data;
				if (componentNewURL !== '' && componentNewURL !== undefined) {
					thisContext.navigate(componentNewURL);
				} else {
					window.location.reload();
				}

			};
			ajaxParam.callbackError = (data) => {
				const {componentErrors} = data;
				if (componentErrors) {
					const errMsg = componentErrors[0];
					notify.error(this.messages[errMsg] || errMsg);
					window.location.reload();
				}
			};

			HelperGoogleAnalytics4.TrackLoginEvent('Google');

			this.ajaxCall('ActionGoogleLogin', {token: token, rememberMe: thisContext.props.rememberMe}, ajaxParam);
		}
	}

	googleOnFailure = (error) => {
		console.error(error);
	}


	componentDidMount() {
		super.componentDidMount();

		// FACEBOOK BEGIN
		(function (d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			js = d.createElement(s);
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
		// FACEBOOK END


		/////////////////////////////////////////
		// GOOGLE BEGIN
		(function (d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];

			if (d.getElementById(id)) {
				return;
			}

			js = d.createElement(s);
			js.id = id;
			js.src = "https://accounts.google.com/gsi/client";
			fjs.parentNode.insertBefore(js, fjs);


			js.addEventListener('load', function (e) {
				window.renderGoogleLoginButton();
			});

		}(document, 'script', 'google-api'));

		// GOOGLE END
		/////////////////////////////////////////

	}


	render() {
		return (
			<ContextSocialLogin.Provider value={this.state}>
				{this.props.children}
			</ContextSocialLogin.Provider>
		)
	}
}

export {ContextSocialLogin, ContextSocialLoginProvider};
